import { useLocation } from 'react-router-dom'

import { EAdminPortalClientPath } from '~/models/api'

function useIsAdminPortalRoute() {
  const { pathname } = useLocation()

  return pathname.includes(EAdminPortalClientPath.admin)
}

export default useIsAdminPortalRoute
